import { Reveal, SectionHead } from "./Reveal";

export const CostComparison = () => (
  <section data-testid="cost-comparison-section" className="py-24 md:py-36 bg-teal text-ivory relative overflow-hidden">
    <div className="pointer-events-none absolute -bottom-40 -left-40 w-[30rem] h-[30rem] rounded-full bg-champagne/10 blur-3xl" aria-hidden="true" />
    <div className="max-w-7xl mx-auto px-5 md:px-10 relative">
      <SectionHead
        index="04"
        eyebrow="The Cost Comparison"
        title="Have You Ever Calculated What Waxing Costs Over 10 Years?"
        dark
      />
      <div className="mt-16 grid md:grid-cols-2 gap-6 items-stretch">
        <Reveal>
          <div data-testid="waxing-cost-card" className="h-full rounded-[2rem] border border-ivory/15 bg-ivory/5 backdrop-blur-sm p-9 md:p-12">
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-champagne">Waxing</p>
            <div className="mt-8 space-y-3 font-light text-ivory/75 text-base md:text-lg">
              <p className="flex justify-between border-b border-ivory/10 pb-3"><span>Per session</span><span className="font-mono">₹500</span></p>
              <p className="flex justify-between border-b border-ivory/10 pb-3"><span>Sessions / year</span><span className="font-mono">× 12</span></p>
              <p className="flex justify-between border-b border-ivory/10 pb-3"><span>Years</span><span className="font-mono">× 10</span></p>
            </div>
            <p className="mt-8 font-display text-5xl md:text-6xl font-light text-ivory/85">= ₹60,000</p>
            <p className="mt-2 text-sm font-light text-ivory/45">…and the appointments still never end.</p>
          </div>
        </Reveal>
        <Reveal delay={0.12}>
          <div data-testid="laser-cost-card" className="relative h-full rounded-[2rem] border border-champagne/50 bg-champagne/10 p-9 md:p-12">
            <span className="absolute top-6 right-6 rounded-full bg-champagne px-4 py-1.5 font-mono text-[0.6rem] uppercase tracking-[0.25em] text-teal-900">
              Krystal Package
            </span>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-champagne">Laser Package</p>
            <div className="mt-8 space-y-3 font-light text-ivory/75 text-base md:text-lg">
              <p className="flex justify-between border-b border-ivory/10 pb-3"><span>10-session package</span><span className="font-mono">Included</span></p>
              <p className="flex justify-between border-b border-ivory/10 pb-3"><span>Annual maintenance sessions</span><span className="font-mono">Included</span></p>
              <p className="flex justify-between border-b border-ivory/10 pb-3"><span>Doctor supervision</span><span className="font-mono">Included</span></p>
            </div>
            <p data-testid="laser-cost-total" className="mt-8 font-display text-5xl md:text-6xl font-light text-champagne-light">= ₹22,500</p>
            <p className="mt-2 text-sm font-light text-ivory/45">One package. A decade of maintenance cover.</p>
          </div>
        </Reveal>
      </div>
      <Reveal delay={0.2}>
        <p data-testid="cost-highlight" className="mt-12 text-center font-display text-2xl md:text-4xl font-light italic text-champagne-light">
          “Potentially save thousands over years of repeated waxing.”
        </p>
        <p className="mt-5 text-center text-xs font-light text-ivory/40 max-w-xl mx-auto leading-relaxed">
          Example calculation based on ₹500 waxing once per month. Actual costs vary depending on frequency and provider.
        </p>
      </Reveal>
    </div>
  </section>
);
